import React, {useContext, useEffect, useState} from 'react';
import axios from 'axios';
import config from '../../config.js';
import UserContext from './UserContext.js';
// css
import '../../assets/css/App.css';

// reactstrap
import {Col, Row} from 'reactstrap';

// timezone
import '@progress/kendo-date-math/tz/all';
import {ZonedDate} from '@progress/kendo-date-math';

// multilingual
import {
    downtimeEndKey,
    systemMaintenanceKey,
    mainMessages,
    downtimeStartKey,
    downtimeTextKey
} from '../../assets/text/MultilingualText.js';
import Alert from "./Alert";
import {useLocalization} from "@progress/kendo-react-intl";


const Downtime = (props) => {
    const {
        siteLanguageDefault,
        globalConfig,
    } = useContext(UserContext);
    const localization = useLocalization();

    const [start, setStart] = useState('');
    const [end, setEnd] = useState('');

    const kendoDateFix = (dateString) => dateString.replace('Dev', 'Dec')

    useEffect(() => {
        let downtime = globalConfig?.downtime
        if (downtime?.start != null && downtime?.end != null) {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            let startDate = new Date(downtime?.start);
            startDate = ZonedDate.fromLocalDate(startDate, timezone).toString().split(' ');
            startDate.splice(5, 1);
            setStart(kendoDateFix(startDate.join(' ')));

            let endDate = new Date(downtime?.end);
            endDate = ZonedDate.fromLocalDate(endDate, timezone).toString().split(' ');
            endDate.splice(5, 1);
            setEnd(kendoDateFix(endDate.join(' ')));
        }
    }, [globalConfig]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {start !== '' && end !== '' && (<Row className="justify-content-md-center k-mb-4">
                <Col xs="7">
                    <Alert
                        type={'system'}
                        title={localization.toLanguageString(systemMaintenanceKey, mainMessages[siteLanguageDefault][systemMaintenanceKey])}
                        message={<div>
                            {localization.toLanguageString(downtimeTextKey, mainMessages[siteLanguageDefault][downtimeTextKey])}
                            <br/>
                            {localization.toLanguageString(downtimeStartKey, mainMessages[siteLanguageDefault][downtimeStartKey])}
                            {start}
                            <br/>
                            {localization.toLanguageString(downtimeEndKey, mainMessages[siteLanguageDefault][downtimeEndKey])}
                            {end}
                            <br/>
                        </div>}
                    />
                </Col>
            </Row>)
            }
        </>
    );
}

export default Downtime;
